import {NavLink} from 'react-router-dom';
import styled, {css} from 'styled-components';

import {colors} from '@app/styles/theme';

interface AsideProps {
    isOpen: boolean;
}

export const LayoutWrapper = styled.div`
    position: relative;
    min-height: 100vh;
    display: flex;
    background-color: ${colors.background};
`;

export const Aside = styled.aside<AsideProps>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 80px;
    display: flex;
    flex-direction: column;
    background-color: ${colors.white};
    border-right: 1px solid ${colors.border};
    z-index: 800;
    overflow: hidden;
    transition: all 0.15s ease-in-out;

    @media print {
        display: none;
    }

    ${(props) =>
        props.isOpen &&
        css`
            width: 320px;
        `}
`;

export const LogoWrapper = styled.div`
    margin: 18px 20px 0;
`;

export const AsideGroup = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const commonItemStyles = css`
    margin-top: 12px;
    padding: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    border-radius: 4px;
    transition: all 0.15s ease-in-out;
    color: ${colors.textPrimary};
    cursor: pointer;
    text-decoration: none;

    svg {
        flex: 0 0 auto;
        transition: all 0.15s ease-in-out;
    }
`;

export const ItemText = styled.span<{isOpen: boolean}>`
    display: ${(props) => (props.isOpen ? 'inline-block' : 'none')};
    margin-left: 12px;
    font-size: 16px;
    font-weight: 500;
    white-space: nowrap;
    transition: all 0.2s ease-in-out;
`;

const asideItemStyles = css`
    ${commonItemStyles};

    &.active,
    &:hover {
        background-color: ${colors.brandPrimary};
        color: ${colors.white};

        svg {
            color: ${colors.white};
        }
    }
`;

export const AsideItem = styled(NavLink)`
    ${asideItemStyles};
`;

export const AsideExternalItem = styled.a`
    ${asideItemStyles};

    &:focus-visible {
        outline: 2px solid ${colors.brandPrimary};
        outline-offset: 2px;
    }
`;

export const AsideToggle = styled.span`
    ${commonItemStyles};

    &:hover {
        color: ${colors.brandPrimary};
        svg {
            color: ${colors.brandPrimary};
        }
    }
`;

export const AsideSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 16px;
`;

export const PageWrapper = styled.div<{asideHidden?: boolean}>`
    display: flex;
    flex-direction: column;
    padding-left: ${(props) => (props.asideHidden ? '16px' : '96px')};
    padding-right: 16px;
    width: 100%;
    transition: padding 0.2s ease-in-out;

    @media print {
        padding: 16px;
    }
`;

export const Header = styled.header`
    width: 100%;
    display: flex;
    flex: 0 0 auto;
    height: 70px;

    @media print {
        display: none;
    }
`;

export const Main = styled.main`
    flex: 1 1 auto;
    width: 100%;
`;
